import type { Headline } from './headlines.ts'
import CrIcon from './CrIcon.tsx'

type Props = {
  items: Headline[]
  onOpenWeek: (weekStart: string | null, key: Headline['key']) => void
  onConfirmBank: () => void
}

function stateGlyph(state?: Headline['state']) {
  if (state === 'below') return '↓'
  if (state === 'tight') return '⚠'
  return '✓'
}

function TileChrome({ h }: { h: Headline }) {
  return (
    <span className="cr-tile-head">
      <span>{h.key === 'lowest' ? `${stateGlyph(h.state)} ${h.label}` : h.label}</span>
      {h.key === 'lowest' && h.sameWeek ? (
        <em className="cr-same-week" data-testid="cr-lowest-same-week">Same week</em>
      ) : (
        <CrIcon name="arrow" />
      )}
    </span>
  )
}

export default function HeadlineNumbers({ items, onOpenWeek, onConfirmBank }: Props) {
  return (
    <div className="cr-periods">
      {items.map((h) => {
        const tileClass = `cr-period${h.danger ? ' danger' : ''}${h.key === 'lowest' ? ' cr-period-lowest' : ''}${h.state ? ` cr-state-${h.state}` : ''}`
        if (h.key === 'today') {
          return (
            <div
              key={h.key}
              className={tileClass}
              data-testid="cr-headline-today"
            >
              <TileChrome h={h} />
              <button
                type="button"
                className={`cr-period-amount${h.danger ? ' cr-neg' : ''}`}
                data-testid="cr-headline-today-amount"
                aria-label={`${h.label} ${h.formatted}`}
                onClick={() => onOpenWeek(h.weekStart, h.key)}
              >
                {h.formatted}
              </button>
              <button
                type="button"
                className="cr-btn cr-confirm-bank"
                data-testid="cr-confirm-bank"
                onClick={onConfirmBank}
              >
                {h.sublabel === 'Open bank sources' ? 'confirm' : `${h.sublabel} · confirm`}
              </button>
            </div>
          )
        }
        return (
          <button
            key={h.key}
            type="button"
            className={tileClass}
            data-testid={`cr-headline-${h.key}`}
            aria-label={`${h.label} ${h.formatted}`}
            onClick={() => onOpenWeek(h.weekStart, h.key)}
          >
            <TileChrome h={h} />
            <strong className={h.danger ? 'cr-neg' : undefined} data-testid={`cr-headline-${h.key}-amount`}>
              {h.formatted}
            </strong>
            <small>{h.sublabel}</small>
          </button>
        )
      })}
    </div>
  )
}
